import LeasesHeaderNav from '../components/LeasesHeaderNav';
import { ErrorPage, ErrorPageContainer } from '@zg-rentals/visual-cohesion';
import { getErrorPageAction } from '../utils/getErrorPageTextProps';
import { usesHeaderNav } from '../constants/routeConstants';

export default function LeasesNotFound() {
  return (
    <LeasesHeaderNav>
      <ErrorPageContainer layout={usesHeaderNav() ? 'header-nav' : 'left-nav'}>
        <ErrorPage
          errorMessage="We can’t find that page"
          errorDetails="That page may have moved or no longer exists. Let’s get you back on track."
          action={getErrorPageAction()}
        />
      </ErrorPageContainer>
    </LeasesHeaderNav>
  );
}
